// material-ui
import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TOOLTIP ||============================== //

export default function Tooltip(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  /**
   * A escala `grey` do projeto mapeia tons zinc: no dark, índices altos (700–900)
   * são mais claros, não superfícies escuras — não usar grey[800] como “painel escuro”.
   */
  const bgColor = isLight ? theme.palette.grey[900] : theme.palette.grey[300];
  const textColor = isLight ? theme.palette.common.white : theme.palette.grey[900];
  const borderColor = isLight ? alpha(theme.palette.common.white, 0.12) : alpha(theme.palette.common.white, 0.1);

  const glass = {
    backdropFilter: 'blur(8px) saturate(120%)',
    WebkitBackdropFilter: 'blur(8px) saturate(120%)',
    border: `1px solid ${borderColor}`
  };

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundImage: 'none !important',
          backgroundColor: `${bgColor} !important`,
          color: `${textColor} !important`,
          borderRadius: theme.shape.borderRadius,
          fontSize: '0.75rem',
          padding: '8px 12px',
          boxShadow: theme.shadows[8],
          ...glass
        },
        arrow: { color: bgColor }
      }
    }
  };
}
